import { Play, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import { VIDEOS, SOCIALS } from "@/content";

function VideoFrame({ video, index, featured = false }) {
  return (
    <article data-testid={`video-card-${index}`} className="group">
      <div className="relative aspect-video overflow-hidden border border-paper/15 bg-charcoal">
        {video.embedUrl ? (
          <iframe
            title={video.title}
            src={video.embedUrl}
            className="absolute inset-0 w-full h-full"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <>
            <img
              src={video.image}
              alt=""
              aria-hidden="true"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-700"
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="flex items-center justify-center w-14 h-14 rounded-full border border-paper/50 text-paper">
                <Play size={20} className="ml-0.5" aria-hidden="true" />
              </span>
            </div>
          </>
        )}
      </div>
      <p className={`mt-4 font-spartan font-bold tracking-tight ${featured ? "text-xl md:text-2xl" : "text-base md:text-lg"}`}>
        {video.title}
      </p>
    </article>
  );
}

export default function Videos() {
  const [featured, ...rest] = VIDEOS;
  return (
    <section id="videos" data-testid="videos-section" className="bg-ink text-paper py-24 md:py-36 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <SectionHeading number="05" title="Watch" dark testId="videos-heading" />

        <div className="mt-14 md:mt-20">
          {featured && (
            <Reveal delay={0.1}>
              <VideoFrame video={featured} index={0} featured />
            </Reveal>
          )}

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-10">
            {rest.map((video, i) => (
              <Reveal key={video.embedUrl || i} delay={0.12 + i * 0.05}>
                <VideoFrame video={video} index={i + 1} />
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <a
            href={SOCIALS.youtube}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="videos-youtube-link"
            className="mt-14 inline-flex items-center gap-3 border border-paper/50 text-paper text-xs font-semibold tracking-[0.22em] uppercase px-8 py-4 rounded-full hover:bg-paper hover:text-ink transition-colors duration-300"
          >
            Watch on YouTube <ArrowUpRight size={16} aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
